<div class="container ratesContainer">
    <div class="row">
        <div class="px-4 mt-3">
            <p class="title">Check Rates</p>
        </div>
    </div>
    <div class="row" id="dropdownRow">
        <!-- <div class="col-lg-4 col-md-4 col-sm-4">
            <div>
                <label for="state" id="rateLbl">State</label>
                <select class="inputBox stateDropdown" id="state" [(ngModel)]="selectedState" (change)="getDistricts()"
                    aria-placeholder="Select State">
                    <option value="" disabled selected>Select State</option>
                    <option *ngFor="let st of states" [value]="st.state">
                        {{st.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7">
            <div>
                <label for="district" id="schoolLbl">School District</label>
                <select id="district" class="inputBox schoolDropdown" aria-placeholder="Enter School District"
                    [(ngModel)]="selectedDistrict" (change)="getDistrictName()">
                    <option value="" disabled selected>Select School District</option>
                    <option *ngFor="let dist of districts" [value]="dist.policyNo">
                        {{dist.client}}
                    </option>
                </select>
            </div>
        </div> -->
        <div class="d-flex flex-wrap px-4">
          <div class="me-4 mb-2">
            <label for="state" class="form-label fw-semibold">State</label>
            <select class="form-select"
              id="state"
              [(ngModel)]="selectedState"
              (change)="getDistricts()"
              aria-placeholder="Select State"
              style="min-width: 193px;">
                <option value="" disabled selected>Select State</option>
                <option *ngFor="let st of states" [value]="st.state">
                    {{st.name}}
                </option>
            </select>
          </div>
          <div>
            <label for="district" class="form-label fw-semibold">School District</label>
            <select
              id="district"
              class="form-select"
              aria-placeholder="Enter School District"
              [(ngModel)]="selectedDistrict"
              (change)="getDistrictName()"
              style="min-width: 275px;">
                <option value="" disabled selected>Select School District</option>
                <option *ngFor="let dist of districts" [value]="dist.policyNo">
                    {{dist.client}}
                </option>
            </select>
          </div>
        </div>
    </div>

    <div class="row">
      <div
        class="d-flex flex-wrap px-4"
        *ngIf="rates.length > 0">
          <div style="margin-right: 5rem;">
              <p style="margin-bottom: 0.5rem;font-size: 1rem;" class="fw-semibold">State</p>
              <p style="font-size: .95rem">{{stateName}}</p>
          </div>
          <div style="margin-right: 5rem;">
              <p style="margin-bottom: 0.5rem;font-size: 1rem" class="fw-semibold">School</p>
              <p style="font-size: .95rem">{{districtName}}</p>
          </div>
          <div style="margin-right: 5rem;">
              <p style="margin-bottom: 0.5rem;font-size: 0.9rem" class="fw-semibold">Coverage Year</p>
              <p style="font-size: .95rem">{{coverageYear}} - {{coverageYear+1}}</p>
          </div>
      </div>
    </div>
    <div
      class="row additional"
      *ngIf="rates.length > 0">
        <div class="px-4 mt-3">
            <p class="avail">Available Coverages</p>
        </div>
        <div>
            <table aria-label="Available Coverages" mat-table [dataSource]="dataSource">


                <ng-container matColumnDef="activity">
                    <th mat-header-cell *matHeaderCellDef> Activity </th>
                    <td mat-cell *matCellDef="let element"> {{element.activity}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="demographics">
                    <th mat-header-cell *matHeaderCellDef> Demographics </th>
                    <td mat-cell *matCellDef="let element"> {{element.demographics}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="marketingPlan">
                    <th mat-header-cell *matHeaderCellDef> Marketing Plan </th>
                    <td mat-cell *matCellDef="let element"> {{element.marketingPlan}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="rate">
                    <th mat-header-cell *matHeaderCellDef> Coverage Rate</th>
                    <td mat-cell *matCellDef="let element"> {{element.rate|currency:'USD'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
    <div class="row mt-4" style="margin-left: .28rem">
        <div class="col-lg-6 mb-2">
            <div class="d-flex justify-content-start align-items-top">
                <img *ngIf="underwriters.logoLoc" class="logoImage mb-2 me-4"
                    src='{{ "./assets/images/"+underwriters.logoLoc+""}}' alt={{underwriters.logoLoc}}>
                <div
                  *ngIf="underwriters.insCo!=''&&underwriters.insCo!=null">
                    <p id="coverageby">Coverage By</p>
                    <div style="color: var(--gray-50, #5F6D7E);font-size: 0.875rem;">
                        {{underwriters.insCo}}
                        <br>
                        {{underwriters.address1}}
                        {{underwriters.city}}, {{underwriters.state}}
                        {{underwriters.zip}}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div *ngIf="generalNotes.length>0">
                <p id="coverageby">General Notes</p>
                <ul class="notes">
                    <li *ngFor="let r of generalNotes" class="ms-3">
                        {{r}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div *ngIf="brochureCode.length>0">
            <p class="brochure">Brochures</p>
            <div class="brContainer d-flex flex-wrap align-content-around justify-content-start">
              <div *ngFor="let brochure of brochureCode">
                <a
                  class="btn btn-outline-light d-flex justify-content-start align-items-center bg-light text-dark my-1 me-2"
                  style="border-color: #D6D7D7 !important"
                  [href]="getPDFLink( brochure.brochureCode)"
                  target="_blank"
                  title="Download Brochure"
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="iconpdf"
                    width="25"
                    height="25"
                    viewBox="0 0 25 28"
                    fill="none"
                    class="me-2">
                    <path
                      d="M0.5 1.5C0.5 0.671572 1.17157 0 2 0H15.5L24.5 9V26.5C24.5 27.3284 23.8284 28 23 28H2C1.17157 28 0.5 27.3284 0.5 26.5V1.5Z"
                      fill="url(#paint0_linear_2012_5169)" />
                    <path
                      d="M15.5 7.5V0L24.5 9H17C16.1716 9 15.5 8.32843 15.5 7.5Z"
                      fill="#BA253D" />
                    <path
                      d="M5.22461 19.9996V15.0996H7.34561C7.78428 15.0996 8.16228 15.1719 8.47961 15.3166C8.79694 15.4566 9.04194 15.6596 9.21461 15.9256C9.38728 16.1916 9.47361 16.5089 9.47361 16.8776C9.47361 17.2416 9.38728 17.5566 9.21461 17.8226C9.04194 18.0886 8.79694 18.2939 8.47961 18.4386C8.16228 18.5786 7.78428 18.6486 7.34561 18.6486H5.85461L6.35861 18.1376V19.9996H5.22461ZM6.35861 18.2636L5.85461 17.7246H7.28261C7.63261 17.7246 7.89394 17.6499 8.06661 17.5006C8.23928 17.3513 8.32561 17.1436 8.32561 16.8776C8.32561 16.6069 8.23928 16.3969 8.06661 16.2476C7.89394 16.0983 7.63261 16.0236 7.28261 16.0236H5.85461L6.35861 15.4846V18.2636Z"
                      fill="white" />
                    <path
                      d="M10.4832 19.9996V15.0996H12.7092C13.2412 15.0996 13.7102 15.2023 14.1162 15.4076C14.5222 15.6083 14.8395 15.8906 15.0682 16.2546C15.2969 16.6186 15.4112 17.0503 15.4112 17.5496C15.4112 18.0443 15.2969 18.4759 15.0682 18.8446C14.8395 19.2086 14.5222 19.4933 14.1162 19.6986C13.7102 19.8993 13.2412 19.9996 12.7092 19.9996H10.4832ZM11.6172 19.0686H12.6532C12.9799 19.0686 13.2622 19.0079 13.5002 18.8866C13.7429 18.7606 13.9295 18.5833 14.0602 18.3546C14.1955 18.1259 14.2632 17.8576 14.2632 17.5496C14.2632 17.2369 14.1955 16.9686 14.0602 16.7446C13.9295 16.5159 13.7429 16.3409 13.5002 16.2196C13.2622 16.0936 12.9799 16.0306 12.6532 16.0306H11.6172V19.0686Z"
                      fill="white" />
                    <path
                      d="M17.5164 17.3046H19.8684V18.2146H17.5164V17.3046ZM17.6004 19.9996H16.4664V15.0996H20.1694V16.0096H17.6004V19.9996Z"
                      fill="white" />
                    <defs>
                      <linearGradient id="paint0_linear_2012_5169" x1="12.5" y1="0" x2="12.5" y2="28"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FA6976" />
                        <stop offset="1" stop-color="#E44B5F" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <div class="text-start">{{ brochure.description }}</div>
                  <!-- <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    style="margin-top: -2px;">
                    <path
                      d="M11.335 2.5C11.335 2.03884 10.9612 1.665 10.5 1.665C10.0388 1.665 9.665 2.03884 9.665 2.5L11.335 2.5ZM9.665 11.6667C9.665 12.1278 10.0388 12.5017 10.5 12.5017C10.9612 12.5017 11.335 12.1278 11.335 11.6667L9.665 11.6667ZM14.4238 10.5904C14.7499 10.2643 14.7499 9.73565 14.4238 9.40957C14.0977 9.08348 13.569 9.08348 13.2429 9.40957L14.4238 10.5904ZM11.0893 12.7441L10.4988 12.1536L11.0893 12.7441ZM9.91074 12.7441L10.5012 12.1536H10.5012L9.91074 12.7441ZM7.7571 9.40957C7.43101 9.08348 6.90232 9.08348 6.57623 9.40957C6.25014 9.73565 6.25014 10.2643 6.57623 10.5904L7.7571 9.40957ZM3.835 13.3333C3.835 12.8722 3.46116 12.4983 3 12.4983C2.53884 12.4983 2.165 12.8722 2.165 13.3333H3.835ZM18.835 13.3333C18.835 12.8722 18.4612 12.4983 18 12.4983C17.5388 12.4983 17.165 12.8722 17.165 13.3333H18.835ZM16.635 17.2275L16.2559 16.4835H16.2559L16.635 17.2275ZM17.7275 16.135L18.4715 16.5141L17.7275 16.135ZM3.27248 16.135L2.52849 16.5141L3.27248 16.135ZM4.36502 17.2275L3.98594 17.9715H3.98594L4.36502 17.2275ZM9.665 2.5L9.665 11.6667L11.335 11.6667L11.335 2.5L9.665 2.5ZM13.2429 9.40957L10.4988 12.1536L11.6797 13.3345L14.4238 10.5904L13.2429 9.40957ZM10.5012 12.1536L7.7571 9.40957L6.57623 10.5904L9.32031 13.3345L10.5012 12.1536ZM10.4988 12.1536C10.4979 12.1546 10.4984 12.1539 10.4998 12.1533C10.5006 12.153 10.5006 12.1532 10.5 12.1532C10.4994 12.1532 10.4994 12.153 10.5002 12.1533C10.5016 12.1539 10.5021 12.1546 10.5012 12.1536L9.32031 13.3345C9.97183 13.986 11.0282 13.986 11.6797 13.3345L10.4988 12.1536ZM2.165 13.3333V13.5H3.835V13.3333H2.165ZM7 18.335H14V16.665H7V18.335ZM18.835 13.5V13.3333H17.165V13.5H18.835ZM14 18.335C14.6863 18.335 15.2512 18.3356 15.71 18.2982C16.1785 18.2599 16.6093 18.1777 17.0141 17.9715L16.2559 16.4835C16.1258 16.5498 15.9392 16.6039 15.574 16.6337C15.199 16.6644 14.7138 16.665 14 16.665V18.335ZM17.165 13.5C17.165 14.2138 17.1644 14.699 17.1337 15.074C17.1039 15.4392 17.0498 15.6258 16.9835 15.7559L18.4715 16.5141C18.6777 16.1093 18.7599 15.6785 18.7982 15.21C18.8356 14.7512 18.835 14.1863 18.835 13.5H17.165ZM17.0141 17.9715C17.6416 17.6518 18.1518 17.1416 18.4715 16.5141L16.9835 15.7559C16.8239 16.0692 16.5692 16.3239 16.2559 16.4835L17.0141 17.9715ZM2.165 13.5C2.165 14.1863 2.16435 14.7512 2.20183 15.21C2.24011 15.6785 2.32228 16.1093 2.52849 16.5141L4.01647 15.7559C3.95021 15.6258 3.89613 15.4392 3.86629 15.074C3.83565 14.699 3.835 14.2138 3.835 13.5H2.165ZM7 16.665C6.28616 16.665 5.80099 16.6644 5.426 16.6337C5.06076 16.6039 4.87416 16.5498 4.74411 16.4835L3.98594 17.9715C4.39066 18.1777 4.82149 18.2599 5.29001 18.2982C5.74878 18.3356 6.31371 18.335 7 18.335V16.665ZM2.52849 16.5141C2.84823 17.1416 3.35842 17.6518 3.98594 17.9715L4.74411 16.4835C4.43082 16.3239 4.1761 16.0692 4.01647 15.7559L2.52849 16.5141Z"
                      fill="#272D37" />
                  </svg> -->
                </a>
              </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-3 col-6-md col-12-sm brContainer" *ngFor="let brcode of brochureCode">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" class="iconpdf" width="25" height="28"
                        viewBox="0 0 25 28" fill="none">
                        <path
                            d="M0.5 1.5C0.5 0.671572 1.17157 0 2 0H15.5L24.5 9V26.5C24.5 27.3284 23.8284 28 23 28H2C1.17157 28 0.5 27.3284 0.5 26.5V1.5Z"
                            fill="url(#paint0_linear_2012_5169)" />
                        <path d="M15.5 7.5V0L24.5 9H17C16.1716 9 15.5 8.32843 15.5 7.5Z" fill="#BA253D" />
                        <path
                            d="M5.22461 19.9996V15.0996H7.34561C7.78428 15.0996 8.16228 15.1719 8.47961 15.3166C8.79694 15.4566 9.04194 15.6596 9.21461 15.9256C9.38728 16.1916 9.47361 16.5089 9.47361 16.8776C9.47361 17.2416 9.38728 17.5566 9.21461 17.8226C9.04194 18.0886 8.79694 18.2939 8.47961 18.4386C8.16228 18.5786 7.78428 18.6486 7.34561 18.6486H5.85461L6.35861 18.1376V19.9996H5.22461ZM6.35861 18.2636L5.85461 17.7246H7.28261C7.63261 17.7246 7.89394 17.6499 8.06661 17.5006C8.23928 17.3513 8.32561 17.1436 8.32561 16.8776C8.32561 16.6069 8.23928 16.3969 8.06661 16.2476C7.89394 16.0983 7.63261 16.0236 7.28261 16.0236H5.85461L6.35861 15.4846V18.2636Z"
                            fill="white" />
                        <path
                            d="M10.4832 19.9996V15.0996H12.7092C13.2412 15.0996 13.7102 15.2023 14.1162 15.4076C14.5222 15.6083 14.8395 15.8906 15.0682 16.2546C15.2969 16.6186 15.4112 17.0503 15.4112 17.5496C15.4112 18.0443 15.2969 18.4759 15.0682 18.8446C14.8395 19.2086 14.5222 19.4933 14.1162 19.6986C13.7102 19.8993 13.2412 19.9996 12.7092 19.9996H10.4832ZM11.6172 19.0686H12.6532C12.9799 19.0686 13.2622 19.0079 13.5002 18.8866C13.7429 18.7606 13.9295 18.5833 14.0602 18.3546C14.1955 18.1259 14.2632 17.8576 14.2632 17.5496C14.2632 17.2369 14.1955 16.9686 14.0602 16.7446C13.9295 16.5159 13.7429 16.3409 13.5002 16.2196C13.2622 16.0936 12.9799 16.0306 12.6532 16.0306H11.6172V19.0686Z"
                            fill="white" />
                        <path
                            d="M17.5164 17.3046H19.8684V18.2146H17.5164V17.3046ZM17.6004 19.9996H16.4664V15.0996H20.1694V16.0096H17.6004V19.9996Z"
                            fill="white" />
                        <defs>
                            <linearGradient id="paint0_linear_2012_5169" x1="12.5" y1="0" x2="12.5" y2="28"
                              gradientUnits="userSpaceOnUse">
                              <stop stop-color="#FA6976" />
                              <stop offset="1" stop-color="#E44B5F" />
                            </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div>
                      <span>{{brcode.description}}</span>
                    </div>
                    <div>
                        <a id="downloadBrowcherLink" [href]="getPDFLink( brcode.brochureCode)" (click)="download()"
                            [download]="brcode.brochureCode" target="_blank" rel="noopener noreferrer" class="brlink">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                fill="none">
                                <path
                                  d="M11.335 2.5C11.335 2.03884 10.9612 1.665 10.5 1.665C10.0388 1.665 9.665 2.03884 9.665 2.5L11.335 2.5ZM9.665 11.6667C9.665 12.1278 10.0388 12.5017 10.5 12.5017C10.9612 12.5017 11.335 12.1278 11.335 11.6667L9.665 11.6667ZM14.4238 10.5904C14.7499 10.2643 14.7499 9.73565 14.4238 9.40957C14.0977 9.08348 13.569 9.08348 13.2429 9.40957L14.4238 10.5904ZM11.0893 12.7441L10.4988 12.1536L11.0893 12.7441ZM9.91074 12.7441L10.5012 12.1536H10.5012L9.91074 12.7441ZM7.7571 9.40957C7.43101 9.08348 6.90232 9.08348 6.57623 9.40957C6.25014 9.73565 6.25014 10.2643 6.57623 10.5904L7.7571 9.40957ZM3.835 13.3333C3.835 12.8722 3.46116 12.4983 3 12.4983C2.53884 12.4983 2.165 12.8722 2.165 13.3333H3.835ZM18.835 13.3333C18.835 12.8722 18.4612 12.4983 18 12.4983C17.5388 12.4983 17.165 12.8722 17.165 13.3333H18.835ZM16.635 17.2275L16.2559 16.4835H16.2559L16.635 17.2275ZM17.7275 16.135L18.4715 16.5141L17.7275 16.135ZM3.27248 16.135L2.52849 16.5141L3.27248 16.135ZM4.36502 17.2275L3.98594 17.9715H3.98594L4.36502 17.2275ZM9.665 2.5L9.665 11.6667L11.335 11.6667L11.335 2.5L9.665 2.5ZM13.2429 9.40957L10.4988 12.1536L11.6797 13.3345L14.4238 10.5904L13.2429 9.40957ZM10.5012 12.1536L7.7571 9.40957L6.57623 10.5904L9.32031 13.3345L10.5012 12.1536ZM10.4988 12.1536C10.4979 12.1546 10.4984 12.1539 10.4998 12.1533C10.5006 12.153 10.5006 12.1532 10.5 12.1532C10.4994 12.1532 10.4994 12.153 10.5002 12.1533C10.5016 12.1539 10.5021 12.1546 10.5012 12.1536L9.32031 13.3345C9.97183 13.986 11.0282 13.986 11.6797 13.3345L10.4988 12.1536ZM2.165 13.3333V13.5H3.835V13.3333H2.165ZM7 18.335H14V16.665H7V18.335ZM18.835 13.5V13.3333H17.165V13.5H18.835ZM14 18.335C14.6863 18.335 15.2512 18.3356 15.71 18.2982C16.1785 18.2599 16.6093 18.1777 17.0141 17.9715L16.2559 16.4835C16.1258 16.5498 15.9392 16.6039 15.574 16.6337C15.199 16.6644 14.7138 16.665 14 16.665V18.335ZM17.165 13.5C17.165 14.2138 17.1644 14.699 17.1337 15.074C17.1039 15.4392 17.0498 15.6258 16.9835 15.7559L18.4715 16.5141C18.6777 16.1093 18.7599 15.6785 18.7982 15.21C18.8356 14.7512 18.835 14.1863 18.835 13.5H17.165ZM17.0141 17.9715C17.6416 17.6518 18.1518 17.1416 18.4715 16.5141L16.9835 15.7559C16.8239 16.0692 16.5692 16.3239 16.2559 16.4835L17.0141 17.9715ZM2.165 13.5C2.165 14.1863 2.16435 14.7512 2.20183 15.21C2.24011 15.6785 2.32228 16.1093 2.52849 16.5141L4.01647 15.7559C3.95021 15.6258 3.89613 15.4392 3.86629 15.074C3.83565 14.699 3.835 14.2138 3.835 13.5H2.165ZM7 16.665C6.28616 16.665 5.80099 16.6644 5.426 16.6337C5.06076 16.6039 4.87416 16.5498 4.74411 16.4835L3.98594 17.9715C4.39066 18.1777 4.82149 18.2599 5.29001 18.2982C5.74878 18.3356 6.31371 18.335 7 18.335V16.665ZM2.52849 16.5141C2.84823 17.1416 3.35842 17.6518 3.98594 17.9715L4.74411 16.4835C4.43082 16.3239 4.1761 16.0692 4.01647 15.7559L2.52849 16.5141Z"
                                  fill="#272D37" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
